<template>
  <div>
    <validation-observer v-slot="{ handleSubmit, reset }">
      <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" class="main_form">
        <div class="coverings_bloc_1 bloc_narrow">
          <p class="paragraph-3">
            {{$t('AFTER_PURCHASE_WITHDRAWAL_FORM')}} <a href="javascript:;" class="link-5">{{$t('WITHDRAWAL_FORM')}}</a> {{$t('GIVEBACK_PAYMENT')}}
          </p>
        </div>
        <div class="coverings_bloc_1 bloc_narrow">
          <validation-provider class="w-100" :name="$t('DECLARATION_VALID_DETAILS')" :rules="{ required: { allowFalse: false } }" v-slot="{ errors, classes }">
            <label class="radio-button-field w-radio">
              <!-- <div class="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button-2 w-radio-input"></div> -->
              <input type="checkbox" class="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button-2 w-radio-input" v-model="declararion.all_details_correct" />
              <span class="paragraph-3 w-form-label">
                {{$t('DECLARATION_VALID_DETAILS')}}
              </span>
            </label>
            <span :class="classes">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div class="coverings_bloc_1 bloc_narrow">
          <validation-provider class="w-100" :name="$t('DECLARATION_INFORMED_FROM_COMPANY')" rules="required" v-slot="{ errors, classes }">
            <label class="radio-button-field w-radio">
              <!-- <div class="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button-2 w-radio-input"></div> -->
              <input type="checkbox" class="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button-2 w-radio-input" v-model="declararion.informed" />
              <span class="paragraph-3 w-form-label"
                >{{$t('DECLARATION_INFORMED_FROM_COMPANY')}}</span
              >
            </label>
            <span :class="classes">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div class="coverings_bloc_1 bloc_narrow">
          <validation-provider class="w-100" :name="$t('DECLARATION_GDPR')" rules="required" v-slot="{ errors, classes }">
            <label class="radio-button-field w-radio">
              <!-- <div class="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button-2 w-radio-input"></div> -->
              <input type="checkbox" class="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button-2 w-radio-input" v-model="declararion.gdpr_consent" />
              <span class="paragraph-3 w-form-label"
                >{{$t('DECLARATION_GDPR')}}</span
              >
            </label>
            <span :class="classes">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div class="columns-13 w-row">
          <div class="w-col w-col-6">
            <h1 class="paragraph-3">{{$t('LEARNED_ABOUT_WEBSITE')}}</h1>
          </div>
          <div class="column-39 w-col w-col-6">
            <div id="w-node-_4d4da81d-6b61-9692-dcce-9742bec74b41-156b8f0a" class="form_field">
              <validation-provider class="w-100" :name="$t('LEARNED_ABOUT_WEBSITE')" rules="required" v-slot="{ errors, classes }">
                <div data-hover="" data-delay="0" class="dropdown w-dropdown custom-select">
                  <select v-model="data.CS_POLICY_HOLDER.WEBSITE_SOURCE">
                    <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLov(data.ET_LOVS, 'WEBSITE_SOURCE')" :key="item.VALUE" :value="item.VALUE">{{
                      item.TEXT
                    }}</option>
                  </select>
                </div>
                <span :class="classes">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>
        <div v-if="data.CS_POLICY_HOLDER.WEBSITE_SOURCE === '5'" class="columns-13 w-row">
          <div class="w-col w-col-6">
            <h1 class="paragraph-3">{{$t('BRANCH_ID')}}</h1>
          </div>
          <div class="column-39 w-col w-col-6">
            <div id="w-node-_4d4da81d-6b61-9692-dcce-9742bec74b41-156b8f0a" class="form_field">
              <validation-provider class="w-100" :name="$t('BRANCH_ID')" rules="required" v-slot="{ errors, classes }">
                <div class="div_form_cell">
                  <input v-model="data.CS_POLICY_HOLDER.BRANCH_ID" type="text" class="text_field_input text-field w-input" maxlength="256" />
                </div>
                <span :class="classes">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>
        <div v-if="data.CS_POLICY_HOLDER.WEBSITE_SOURCE === '9'" class="columns-13 w-row">
          <div class="w-col w-col-6">
            <h1 class="paragraph-3">{{$t('AGENT_ID')}}</h1>
          </div>
          <div class="column-39 w-col w-col-6">
            <div id="w-node-_4d4da81d-6b61-9692-dcce-9742bec74b41-156b8f0a" class="form_field">
              <validation-provider class="w-100" :name="$t('AGENT_ID')" rules="required" v-slot="{ errors, classes }">
                <div class="div_form_cell">
                  <input v-model="data.CS_POLICY_HOLDER.AGENT_ID" type="text" class="text_field_input text-field w-input" maxlength="256" />
                </div>
                <span :class="classes">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>
        <button type="submit" id="w-node-cae7ea47-eb8f-f4a2-530c-382961137893-13d36bc6" class="submit-button submit-button-2 submit-button-extra-large w-button" :disabled="DisableCompletePurchase">
          {{$t('PURCHASE_COMPLETION')}}
        </button>
        <p class="paragraph-4">
          {{$t('JCC_PAYMENT_REDIRECT_BACK')}}
        </p>
      </form>
    </validation-observer>
  </div>
</template>

<script>

export default {
  data() {
    return {
      declararion: {
        all_details_correct: false,
        informed: false,
        gdpr_consent: false
      }
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    DisableCompletePurchase() {
      return !(this.declararion.all_details_correct && this.declararion.informed && this.declararion.gdpr_consent);
    }
  },
  methods: {
    submitForm() {
      this.$emit('payment');
    }
  }
};
</script>
